import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { AutenticationService } from '../../../autentication/autentication.service';
import { Auth } from '../../../autentication/Auth';
import { EventTypes } from '../../../shared/EventTypes';
import { ModalTermsComponent } from '../../../shared/modal-terms/modal-terms.component';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { CloseAccountService } from '../close-account.service';
import { Requisicao } from '../models/requisicao.model';

@Component({
	selector: 'app-close-account-terms',
	templateUrl: './terms.component.html',
	styleUrls: ['./terms.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class CloseAccountTermsComponent implements OnInit {

	public form: FormGroup;
	public contractChecked = false;
	public submittedForm = false;
	private request: Requisicao;

	constructor(
		private router: Router,
		public dialog: MatDialog,
		private closeAccountService: CloseAccountService,
		private autenticationService: AutenticationService,
	) {}

	ngOnInit(): void {
		this.validateRequest();
	}

	validateRequest() {
		this.request = this.closeAccountService.getCreatedRequest()

		if (!this.request) {
			this.goBack();
		}
	}

	onSetSignatureForm(form: FormGroup) {
		this.form = form;
	}

	public onFinish(message: boolean) {
		this.submittedForm = message;

		if (!this.contractChecked || this.form.invalid) {
			return;
		}

		this.addAuthToken();
		this.sendSignature();
	}

	changeTerms(checked: boolean) {
		this.contractChecked = checked;
	}

	openModal(): void {
		this.closeAccountService.getTerms().subscribe(data => {
			if (data.Sucesso && data.Existe) {
				this.dialog.open(ModalTermsComponent, {
					width: '700px',
					height: '500px',
					data: {
						title: 'Termos de encerramento',
						text: data.Retorno
					}
				});
			}
		});
	}

	addAuthToken() {
		if (this.form.value.token === undefined) {
			Auth.passToken = '';
		} else {
			Auth.passToken = this.form.value.token;
		}
	}

	sendSignature() {
		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(data => {
			if (data.Sucesso) {
				this.sendRequest();
			}
		}, error => {
			this.handleError(error);
		});
	}

	sendRequest() {
		this.closeAccountService.postRequest(this.request).subscribe(data => {
			if (data.Sucesso) {
				if (data.Mensagem) {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: data.Mensagem });
				}
				this.goNext();
			}
		}, error => {
			this.handleError(error);
		});
	}

	handleError = (error) => AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
	onPressCancel = () => this.goBack();
	goBack = () => this.router.navigate(['minha-conta/encerramento/requisicao']);
	goNext = () => this.router.navigate(['minha-conta/encerramento/status']);

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/close-account/terms/terms.component.ts